import { useState, useCallback } from 'react';
import { reject } from 'lodash/fp';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

/**
 * A hook to manage (list, add, remove) the container group visibility records
 */
export function useContainerVisibilityGroups({
  eventId,
  initialState,
  scenarioId,
}) {
  const [containerVisibilityGroups, setVisibilityGroups] =
    useState(initialState);

  const createContainerVisibilityGroup = useCallback(
    group => {
      request
        .post(routes.ON_DEMAND_PRACTICE.CONTAINER_VISIBILITY_GROUPS, {
          group_id: group.id,
          scenario_id: scenarioId,
        })
        .then(containerVisibilityGroup => {
          setVisibilityGroups(contents => [
            ...contents,
            containerVisibilityGroup,
          ]);
        });
    },
    [scenarioId],
  );

  const removeContainerVisibilityGroup = useCallback(
    containerVisibilityGroup => {
      request
        .delete(
          routes.ON_DEMAND_PRACTICE.CONTAINER_VISIBILITY_GROUP(
            containerVisibilityGroup.id,
          ),
          { scenario_id: scenarioId },
        )
        .then(() => {
          setVisibilityGroups(reject({ id: containerVisibilityGroup.id }));
        });
    },
    [scenarioId],
  );

  return {
    data: containerVisibilityGroups,
    remove: removeContainerVisibilityGroup,
    create: createContainerVisibilityGroup,
  };
}
